<template>
  <div class="not-found-container">
    <div class="error-content">
      <h1 class="error-code">404</h1>
      <h2 class="error-title">Page Not Found</h2>
      <p class="error-message">The page you are looking for does not exist.</p>
      <p class="error-message-marathi">आपण शोधत असलेले पृष्ठ अस्तित्वात नाही.</p>
      <router-link to="/" class="home-button">
        <i class="fa fa-home"></i> Go to Home
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.error-content {
  text-align: center;
  color: white;
  max-width: 600px;
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.error-title {
  font-size: 36px;
  margin: 20px 0;
  font-weight: 600;
}

.error-message {
  font-size: 18px;
  margin: 10px 0;
  opacity: 0.9;
}

.error-message-marathi {
  font-size: 18px;
  margin: 10px 0;
  opacity: 0.9;
  font-family: "Laila", serif;
}

.home-button {
  display: inline-block;
  margin-top: 30px;
  padding: 12px 30px;
  background-color: white;
  color: #667eea;
  text-decoration: none;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.home-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  color: #667eea;
  text-decoration: none;
}

.home-button i {
  margin-right: 8px;
}

@media (max-width: 767px) {
  .error-code {
    font-size: 80px;
  }

  .error-title {
    font-size: 28px;
  }

  .error-message,
  .error-message-marathi {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue